module.exports = __webpack_public_path__ + "static/25-b4af87e25f8becd3ae177d0fcf4d597f.jpg";